import { contentTypeJson } from "components/CommonLib/CommonLib";
import { HttpInstance } from "lib/HttpLib";

// ==================== GET ====================
// [GET] 미지출 내역 검색 조건 받아오기 및 권한 세팅
export async function getUnspentSearchParam() {
  return await HttpInstance.get(
    process.env.REACT_APP_SALARY_SERVER + "/cashbook/unspent/search_param",
    {
      params: {},
    },
  );
}

// [GET] 미지출 내역 리스트 검색
export async function getUnspentList(queryData) {
  const { page, searchParams } = queryData;
  const formData = new FormData();

  formData.append("search_param", JSON.stringify(searchParams));
  formData.append("page_num", page);

  return await HttpInstance.post(
    process.env.REACT_APP_SALARY_SERVER + "/cashbook/unspent/search",
    formData,
    contentTypeJson,
  );
}
